const searchParamEqualsOne = (searchParam, ...expectedValues) => {
  return traffic => {
    const urlObject = new URL(traffic.url.toLowerCase())
    return expectedValues.some(expValue => {
      const value = urlObject.searchParams.get(searchParam)
      return value !== null && value === expValue
    })
  }
}

export default searchParamEqualsOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/searchParamEqualsOne.js